module.exports = __webpack_public_path__ + "img/icon_left_point_wh.a0d5a718.svg";